import { useCallback, useEffect, useRef, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";

export const NotificationBell = () => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const lastTop = useRef(null);
  const nav = useNavigate();

  const load = useCallback(async () => {
    const { data: d } = await api.get("/notifications");
    const top = d.items[0];
    if (lastTop.current !== null && top && top.id !== lastTop.current && !top.read) toast.info(top.title, { description: top.body });
    lastTop.current = top ? top.id : "";
    setData(d);
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(() => document.visibilityState === "visible" && load(), 15000);
    return () => clearInterval(t);
  }, [load]);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size="icon" variant="outline" className="rounded-full relative" data-testid="notif-bell-btn">
          <Bell className="h-4 w-4" />
          {data.unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-white text-[10px] font-bold grid place-items-center" data-testid="notif-unread-count">{data.unread}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notif-popover">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <span className="font-semibold text-sm">Notifikasi</span>
          <Button size="sm" variant="ghost" onClick={readAll} data-testid="notif-read-all-btn"><CheckCheck className="h-4 w-4 mr-1" />Tandai dibaca</Button>
        </div>
        <div className="max-h-80 overflow-y-auto thin-scroll divide-y">
          {data.items.length === 0 && <p className="text-sm text-muted-foreground p-4 text-center">Belum ada notifikasi.</p>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => nav(n.url || "/live")} className={`w-full text-left px-4 py-3 hover:bg-accent ${n.read ? "" : "bg-primary/5"}`}>
              <div className="text-sm font-semibold flex items-center gap-2">{!n.read && <span className="h-2 w-2 rounded-full bg-primary" />}{n.title}</div>
              <div className="text-xs text-muted-foreground">{n.body}</div>
              <div className="text-[11px] text-muted-foreground mt-1">{fmtDate(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
